<template>
<div :ref="loadingobj">  
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'请选择标签进行定位',ischange:true,width:'200px',clearable:true,filterable:true}" 
                :value="searchlabel"
                :list="labellist"
                @finish="(val)=> {
                    focuslabel(val)
                }"
            />
        </el-form-item>
        </el-form>
    </div>

    <div>
        <div class="TTL-form-submit-box">
            <el-form :inline="false">
                <el-form-item>
                    <div :class="item.isshow ? 'ER-box-info box-active' : 'ER-box-info' " v-for="(item,index) in settinginfo" :key="index" :ref="item.labelname">

                        <!-- 系统图标 -->
                        <el-tooltip placement="right">
                        <template #content>
                        <div style="padding:10px">
                        <el-image :src="item.thumb" style="width:250px;border-radius:30px"/>
                        </div>
                        </template>
                        <wcupload :option="{size:'middle',returnsize:'base', phototype:'system'}" 
                            :value="item.thumb" 
                            @finish="(val)=> {
                                item.thumb=val.url;
                                UpdateSetting(index)
                            }" 
                        />
                        </el-tooltip>

                        <!-- 图标标签 -->
                        <div class="er-box left20">
                            <span>，图标标签</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'图标标签',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.label"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.label=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                        </div>

                        <!-- 复制标签 -->
                        <wcimage class="left10" :option="{size:'mini'}" :value="require('@/assets/icon/copy.png')"  @click="$method.COPY_TEXT({title:item.label}) "/>

                        <!-- 标签名称 -->
                        <div class="er-box left20">
                            <span>，标签名称</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'标签名称',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.labelname"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.labelname=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                        </div>


                        <!-- 标签名称 -->
                        <div class="er-box left20">
                            <span>，标签备注</span>
                            <wcinput class="left15"
                                :option="{type:'input',placeholder:'标签备注',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
                                :value="item.note"
                                @finish="(val)=> {
                                    if(val.type=='input' || val.type=='change') {
                                        item.note=val.value;
                                        UpdateSetting(index)
                                    }
                                }"
                            />
                        </div>

                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>

</template>

<script>
import INTERFACE_MODEL_ICON_SETTING from '@/Interface/Es/sysicon';

export default {
    components:{

    },
    data() {
        return {
            loadingobj:'sysicon',
            settinginfo:[], //设置信息      
            labellist:[], //标签列表
            searchlabel:'', //定位标签名称

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetSettingInfo();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetSettingInfo();
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetSettingInfo();
            }
        },


        /** 数据更新 **/
        UpdateSetting(index) {
            var data=this.settinginfo[index];
            INTERFACE_MODEL_ICON_SETTING.UPDATE_SYS_ICON(data).then((res) => {
                if(res.status > 0) return false;
            });
        },



        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取运费信息数据 **/
        GetSettingInfo() {
            INTERFACE_MODEL_ICON_SETTING.GET_SYS_ICON_ALL().then((res) => {
                if(res.status > 0) return false;
                this.settinginfo=res.data;
                this.labellist=[];
                for(var i=0;i < res.data.length; i++) {
                    this.labellist.push({id:res.data[i].id,name:res.data[i].labelname,label:res.data[i].label});
                }
            });
        },


        /** 聚焦内容 **/
        focuslabel(val) {
            if(val.valuename=='') return false;

            this.$refs[val.valuename][0].scrollIntoView({behavior:'smooth',block:'center'}); 
            for(var i=0; i < this.settinginfo.length; i++) 
            this.settinginfo[i]['isshow']=this.settinginfo[i]['labelname']==val.valuename ? this.settinginfo[i]['isshow']=true : this.settinginfo[i]['isshow']=false;
            var that=this;
            setTimeout(() => {
                for(var i=0; i < that.settinginfo.length; i++) that.settinginfo[i]['isshow']=false
            }, 2000);
        },


    },
}
</script>
<style scoped>
.ER-box-info {display: inline-flex;align-items: center;width:100%;padding:30px 50px;}
.ER-box-title {font-size: 13px;color:#666666;}
.ER-question {width:15px;height: 15px;}
.ER-question .image {width:15px;height: 15px;}
.er-select-member {width:400px;height: 150px;border-radius: 15px;background-color: #F0F2F5;border:1px solid #D4D7DE;padding:0 20px 20px 20px;overflow-y: auto;cursor: pointer;}
.er-select-member::-webkit-scrollbar {width:0;}
.er-member-title {color:#666666;letter-spacing: 1px;padding:5px 0;font-size:12px;display: inline-flex;align-items: center;width:100%;font-weight: 550;position:sticky;top:0;background-color:#F0F2F5;z-index: 10;}
.er-member-title h {position: absolute;right:0;color:red;}
.er-member-info {padding:5px 8px;border-radius: 20px;border:1px solid #CDD0D6;display:inline-flex;align-items: center;background-color:#ffffff;margin-bottom:10px;position: relative;}
.er-member-info .el-image {width:20px;height:20px;border-radius: 50%;}
.er-member-info span {color:#666666;font-size:12px;line-height:18px;}
.er-member-info a {cursor: pointer;width:15px;height: 15px;background-image: url('@/assets/icon/close-blue.png');background-repeat: no-repeat;background-size: 15px;background-position: center;}
.er-box {display: inline-flex;align-items: center;}
.er-box span {font-size:12px;color:#666666;}
.box-item-note {width:100px;}
.box-active {background-color: #F2F6FC;}
</style>